import {IFailedLayerInfo} from '../interfaces/models'
import {ISourceDescription} from '../interfaces/models'

export class DeniedServiceInfo implements IFailedLayerInfo {
  public sourceDescription: ISourceDescription
  public error: Error
  public url: string
  constructor(sourceDescription: ISourceDescription, error: Error) {
    this.url = sourceDescription.id
    this.sourceDescription = sourceDescription
    this.error = error
  }
}
